export function getResouceUrl(contentUrl, filterFields, preventZeroFields) {
  let filterUrl = '?'
  for (const key in filterFields) {
    const isArray = Array.isArray(filterFields[key])
    let hasVAlue = false
    if (isArray && filterFields[key].length > 0) {
      hasVAlue = true
    } else if (!isArray && filterFields[key]) {
      hasVAlue = true
    }
    if (
      !!preventZeroFields &&
      preventZeroFields.length &&
      preventZeroFields.includes(key) &&
      filterFields[key] !== undefined
    ) {
      hasVAlue = true
    }
    if (hasVAlue) {
      filterUrl += `${key}=${filterFields[key]}&`
    }
  }
  return `${contentUrl}${filterUrl}`
}

export function parseFilterParams(params) {
  const filterArguments = params ? params.split('/') : []
  const filterFields = {}
  filterArguments.forEach((item, index) => {
    if (index % 2 === 0 && filterArguments[index + 1]) {
      filterFields[item] = filterArguments[index + 1]
    }
  })
  return filterFields
}
